import { render, staticRenderFns } from "./TableProjects.vue?vue&type=template&id=4a25bb7e&"
import script from "./TableProjects.vue?vue&type=script&lang=js&"
export * from "./TableProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports